import SectionContainer from '@/components/SectionContainer/SectionContainer'
import { buildIdFromText } from '@/utils'

/* INJECT_SECTIONS_IMPORT */
import ProductGallery from '@/sections/ProductGallery/ProductGallery'
import AboutHero from '@/sections/AboutHero/AboutHero'
import LifestyleGallery from '@/sections/LifestyleGallery/LifestyleGallery'
import HomeProductList from '@/sections/HomeProductList/HomeProductList'
import FourOhFour from '@/sections/FourOhFour/FourOhFour'
import { Fragment, useMemo } from 'react'
import ProductPage from '@/sections/ProductPage/ProductPage'

const SECTIONS = {
  /* INJECT_SECTIONS_COMPONENT_TYPE */
  productGallery: ProductGallery,
  aboutHero: AboutHero,
  lifestyleGallery: LifestyleGallery,
  homeProductList: HomeProductList,
  fourOhFour: FourOhFour,
  productPage: ProductPage,
}

const DARK_SECTIONS = ['aboutHero', 'fourOhFour']

function Sections({ sections }) {
  const sectionsFiltered = useMemo(() => {
    const _sections = sections?.filter(
      sectionArr => !sectionArr?.section[0]?.cmsSettings?.isHidden && sectionArr?.section,
    )
    return _sections
  }, [sections])

  if (!sectionsFiltered?.length) return null

  return (
    <>
      {sectionsFiltered.map((sectionArr, i) => {
        if (!sectionArr?.section) {
          console.warn('No sections tied to data ', sectionArr)
          return null
        }

        const sectionAfter = sectionsFiltered[i + 1]?.section[0]
        const sectionObj = sectionArr?.section[0]

        if (!sectionObj._type) {
          return null
        }

        if (!SECTIONS[sectionObj._type]) {
          console.warn('No section found with type ', sectionObj._type)
          return null
        }

        if (sectionObj?.cmsSettings?.isHidden) {
          return null
        }

        const SectionComponent = SECTIONS[sectionObj._type]

        let sectionTypeAfter = sectionAfter?._type
        if (i === sectionsFiltered.length - 2 && infiniteScroll) {
          sectionTypeAfter = sectionsFiltered[0]?.section[0]?._type
        }

        return (
          <Fragment key={`${i}_${sectionObj._id}_${buildIdFromText(sectionObj?.cmsSettings?.cmsTitle || '')}`}>
            <SectionContainer
              cmsTitle={sectionObj?.cmsSettings?.cmsTitle || ''}
              _type={sectionObj._type}
              sectionsLength={sectionsFiltered.length}
              nextSectionType={sectionTypeAfter}
              isDark={DARK_SECTIONS.includes(sectionObj._type)}
            >
              <SectionComponent {...sectionObj} />
            </SectionContainer>
          </Fragment>
        )
      })}
    </>
  )
}

export default Sections
